import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SlTypographyComponent } from '../sl-typography/sl-typography.component';
import { SlDropdownInterface } from '../utils/global-interfaces/sl-global.interfaces';

@Component({
  selector: 'sl-menu-item',
  standalone: true,
  imports: [CommonModule, SlTypographyComponent],
  templateUrl: './sl-menu-item.component.html',
  styleUrl: './sl-menu-item.component.scss',
})
export class SlMenuItemComponent<T> {
  @Input({ required: true })
  item!: SlDropdownInterface<T>;
  @Input()
  icon = '';
  @Input()
  isDisabled = false;
  @Input()
  isSelected = false;
  @Input()
  iconSelected? = '';
  @Input()
  weight: 'light' | 'regular' | 'medium' | 'bold' | 'italic' = 'regular';

  @Input() color?: string;
  @Output()
  clickEvent: EventEmitter<SlDropdownInterface<T>> = new EventEmitter();
  @Output()
  keyDownEvent: EventEmitter<KeyboardEvent> = new EventEmitter();

  onClickItem(clickedItem: SlDropdownInterface<T>) {
    this.clickEvent.emit(clickedItem);
  }

  onKeyDown(event: KeyboardEvent) {
    this.keyDownEvent.emit(event);
  }
}
